export default __webpack_public_path__ + "static/adventure-store-5bbc5cec52c42e26392f5cc9ea3c6d3e.webp";